import gql from 'graphql-tag';

export default gql`
  mutation RemoveFavoriteMeal($mealId: Int!) {
    cookbook {
      removeFavoriteMeal(mealId: $mealId) {
        ... on BasicMutationSuccess {
          code
          __typename
        }
        ... on UnauthorizedException {
          code
          __typename
        }
      }
    }
  }
`;
